'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'fire';
var width = 448;
var height = 512;
var aliases = [128293];
var unicode = 'f06d';
var svgPathData = 'M176.9-40.2c36.7 35.1 68 73.2 94.8 116.4 14.9-19.1 31.1-37 48.3-54.2 27.4 27.5 51.9 56.2 72.4 89.3 27.2 43.9 55.6 106.4 55.6 176.6 0 123.7-100.3 224-224 224S0 411.7 0 288c0-91.1 41.1-170 80.5-225 27.8-38.7 60.2-72.4 96.4-103.2zm-.6 21.6C145.1 8.3 117.5 38.9 93.5 72.3 55 126 16 201.6 16 288 16 402.9 109.1 496 224 496s208-93.1 208-208c0-66.1-26.8-125.6-53.2-168.2-16.8-27.2-36.4-52.3-58.8-75-18.1 18.7-34.1 39.1-49.8 59.9-26.9-44.4-56.6-86.9-94-123.2zM303.4 408.3c-23.6 15.7-49.1 23.7-77.7 23.7-35 0-67.4-11.3-91.3-33.1-24.1-22-38.4-53.7-38.4-92.1 0-37.9 18.1-70 34.9-91.8 13.6-17.6 29.5-31.8 46.9-45.3 28.6 35.7 56.7 71.8 85 107.7l50.8-59.1c8.5 11.3 16.8 22.1 23.1 34.8 28.6 52.6 16.1 120.8-33.4 155.3zM112 306.8c0 68.6 50.6 109.2 113.7 109.2 25.3 0 47.7-7 68.8-21 48.1-33.6 52.3-105.9 18.3-151.2L262.3 302.6 175.2 192S112 241.2 112 306.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;